import React, { useState } from 'react';
import './Capabilities.css';
import '../scrollReveal.css';
import useScrollReveal from '../hooks/useScrollReveal';
import industrialModalVid from '../imgs/industrial_3d_modal-vid.mp4';
import advance_cad_vid from '../imgs/advanced_cad_vid.mp4';
import precision_scanning from '../imgs/precision_scanning_vid.mp4';

const capabilities = [
  {
    title: 'Carbon Fiber & Aero Components',
    short: 'Custom front splitters, rear diffusers, side skirts, wings, and full aero kits engineered for your exact build.',
    long: 'Every aero component is designed around your car\'s specific geometry. We scan, model, and fabricate parts that fit flush and perform — from track-day wings to show-quality full-body kits for Lamborghini, Ferrari, McLaren, and more.',
    video: precision_scanning,
  },
  {
    title: 'Custom CAD & Body Design',
    short: 'One-off body modifications, custom vents, intakes, and styling elements modeled from scratch in Fusion 360.',
    long: 'Have an idea for a look no one else has? We take your vision from sketch to production-ready model. Whether it\'s a widebody conversion concept, custom hood vents, or a full restyling, we engineer it to fit your car perfectly.',
    video: advance_cad_vid,
  },
  {
    title: 'Precision 3D Scanning & Replication',
    short: 'Laser-accurate scanning of OEM and aftermarket parts for flawless replication, modification, or one-off custom work.',
    long: 'We scan your existing parts to create exact digital replicas — perfect for discontinued OEM components, custom modifications to factory pieces, or building bespoke parts that need to fit within tight factory tolerances.',
    video: industrialModalVid,
  },
];

const icons = [
  <svg className="capability-icon" viewBox="0 0 24 24">
    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>,
  <svg className="capability-icon" viewBox="0 0 24 24">
    <path d="M12 19l7-7 3 3-7 7-3-3z" stroke="currentColor" strokeWidth="2" fill="none"/><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" stroke="currentColor" strokeWidth="2" fill="none"/><path d="M2 2l7.586 7.586" stroke="currentColor" strokeWidth="2" fill="none"/><circle cx="11" cy="11" r="2" stroke="currentColor" strokeWidth="2" fill="none"/>
  </svg>,
  <svg className="capability-icon" viewBox="0 0 24 24">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" stroke="currentColor" strokeWidth="2" fill="none"/>
  </svg>,
];

const Capabilities = () => {
  const [modalData, setModalData] = useState(null);
  const sectionRef = useScrollReveal();

  return (
    <section className="capabilities-section" ref={sectionRef}>
      <div className="capabilities-container">
        <div className="section-header">
          <div className="section-label" data-reveal="fade-down">What We Build</div>
          <h2 data-reveal="fade-up" data-delay="100">Built for Exotic Cars</h2>
          <p className="section-subtitle" data-reveal="fade-up" data-delay="200">
            From carbon fiber aero kits to one-off custom body work — precision fabrication for the world's most exclusive vehicles.
          </p>
        </div>

        <div className="capabilities-grid">
          {capabilities.map((cap, index) => (
            <div
              key={index}
              className="capability-card"
              data-reveal="flip"
              data-delay={String((index + 1) * 150)}
              onClick={() => setModalData({ ...cap, icon: icons[index] })}
            >
              <div className="card-index">{String(index + 1).padStart(2, '0')}</div>
              <div className="icon-container">{icons[index]}</div>
              <h3>{cap.title}</h3>
              <p>{cap.short}</p>
              <div className="card-cta">
                View Details <span className="card-cta-arrow">→</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {modalData && (
        <div className="modal-overlay" onClick={() => setModalData(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={() => setModalData(null)}>✕</button>
            <video className="modal-video" autoPlay loop muted playsInline>
              <source src={modalData.video} type="video/mp4" />
            </video>
            <div className="modal-text">
              <h2>{modalData.title}</h2>
              <p>{modalData.long}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Capabilities;
